import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromTeamTypeReducer from './team-types.reducer';
import type { AdminState } from '../index';

// Same feature selector as `selectAdminState` in `../index`, declared here so
// this file does not import the index at runtime: the index re-exports these
// selectors, and that import cycle threw "Cannot access 'selectAdminState'
// before initialization" the first time a spec loaded the admin store
// (SCRUM-623). `AdminState` is a type-only import, which TypeScript erases.
const selectAdminState = createFeatureSelector<AdminState>('admin');

export const selectTeamTypesRootState = createSelector(selectAdminState, (state: AdminState | undefined) => state?.teamTypes);

export const selectAllTeamTypes = createSelector(selectTeamTypesRootState, (state) => (state ? fromTeamTypeReducer.selectAllTeamTypesData(state) : []));

export const selectTeamTypesLoading = createSelector(selectTeamTypesRootState, (state) => (state ? fromTeamTypeReducer.selectTeamTypesLoading(state) : false));

export const selectTeamTypesError = createSelector(selectTeamTypesRootState, (state) => (state ? fromTeamTypeReducer.selectTeamTypesError(state) : null));

export const selectCreateTeamTypeSuccess = createSelector(selectTeamTypesRootState, (state) => (state ? fromTeamTypeReducer.selectCreateTeamTypeSuccess(state) : false));

export const selectUpdateTeamTypeSuccess = createSelector(selectTeamTypesRootState, (state) => (state ? fromTeamTypeReducer.selectUpdateTeamTypeSuccess(state) : false));

export const selectTeamTypeById = (id: number) => createSelector(selectTeamTypesRootState, (state) => (state ? fromTeamTypeReducer.selectTeamTypeByIdData(id)(state) : undefined));
